import React from "react";
import { IIcon } from "./Icon.types";

const BackwardIcon: React.FC<IIcon> = ({
  width= "32",
  height= "32",
  fill= "#FFFFFF",
  viewBox= "0 0 32 32",
  onClick,
  className,
}: IIcon): React.JSX.Element => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      stroke={fill}
      viewBox={viewBox}
      onClick={onClick}
      className={className}
      data-testid="backwardIcon"
    >
      <path
        d="M16.5 7L20 7C21.78 7 23.5201 7.52784 25.0001 8.51677C26.4802 9.50571 27.6337 10.9113 28.3149 12.5558C28.9961 14.2004 29.1743 16.01 28.8271 17.7558C28.4798 19.5016 27.6226 21.1053 26.364 22.364C25.1053 23.6226 23.5016 24.4798 21.7558 24.8271C21.1748 24.9426 20.5867 25 20 25"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M20 3L16 7L20 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M15 3L11 7L15 11"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M9.61383 16V24H7.92242V17.6055H7.87555L6.04352 18.7539V17.2539L8.02398 16H9.61383ZM14.2119 24.1758C13.54 24.1732 12.9619 24.0078 12.4775 23.6797C11.9958 23.3516 11.6247 22.8763 11.3643 22.2539C11.1064 21.6315 10.9788 20.8828 10.9814 20.0078C10.9814 19.1354 11.1104 18.3919 11.3682 17.7773C11.6286 17.1628 11.9997 16.6953 12.4814 16.375C12.9658 16.0521 13.5426 15.8906 14.2119 15.8906C14.8812 15.8906 15.4567 16.0521 15.9385 16.375C16.4229 16.6979 16.7952 17.1667 17.0557 17.7812C17.3161 18.3932 17.445 19.1354 17.4424 20.0078C17.4424 20.8854 17.3122 21.6354 17.0518 22.2578C16.7939 22.8802 16.4242 23.3555 15.9424 23.6836C15.4606 24.0117 14.8838 24.1758 14.2119 24.1758ZM14.2119 22.7734C14.6702 22.7734 15.0361 22.543 15.3096 22.082C15.583 21.6211 15.7184 20.9297 15.7158 20.0078C15.7158 19.401 15.6533 18.8958 15.5283 18.4922C15.4059 18.0885 15.2314 17.7852 15.0049 17.582C14.7809 17.3789 14.5166 17.2773 14.2119 17.2773C13.7562 17.2773 13.3916 17.5052 13.1182 17.9609C12.8447 18.4167 12.7067 19.099 12.7041 20.0078C12.7041 20.6224 12.7653 21.1354 12.8877 21.5469C13.0127 21.9557 13.1885 22.263 13.415 22.4687C13.6416 22.6719 13.9072 22.7734 14.2119 22.7734Z"
        fill="white"
      />
    </svg>
  );
};

export default BackwardIcon;
